import { SignInTrigger } from '@at/connected-signin'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useAfterSignInUrl = (trigger: SignInTrigger) => {
    const { pathname, search } = useLocation()

    return useMemo(() => {
        const existingSearchParams = Object.fromEntries(new URLSearchParams(search))

        const url = (extraParams: Record<string, string>): string => {
            const afterSignInSearchParams = new URLSearchParams({
                ...existingSearchParams,
                ...extraParams,
            })

            const signInSearchParams = new URLSearchParams({
                'after-signin-url': pathname + '?' + afterSignInSearchParams.toString(),
                authTrigger: trigger,
            })
            return `/secure/signin?${signInSearchParams.toString()}`
        }

        return {
            searchFormAfterSignInUrl: url({ showSearchForm: 'true' }),
            saveASearchAfterSignInUrl: url({ showSaveSearch: 'true' }),
            savedSearchesAfterSignInUrl: url({ showSavedSearches: 'true' }),
        }
    }, [pathname, search, trigger])
}
